
import { useAppSelector } from "../../../Redux/store";
import { createFile, downloadFile } from "../../../helpers/files";
import { ModalUI } from "../ModalUI";
import { InscribeUI } from "./InscribeUI";

interface IProps {
    onClose(): void;
}

export const InscribeModal: React.FC<IProps> = ({onClose: _onClose}) => {

    const codeSrc = useAppSelector(state => state.developerSandbox.codeSrc)
    const onClose = () => _onClose();

    const onDownload = () => {
        downloadFile(
            createFile(
                [decodeURIComponent(codeSrc)], 
                'index.html',
                { type: 'text/html' }
            )
        )
    };

return (
        <ModalUI onClose={onClose} maxHeight={500} maxWidth={600}>
            <InscribeUI onDownload={onDownload}/>
        </ModalUI>
    )   
}
